import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { IconLoaderService } from '@embraceit/components';
import { Store } from '@ngxs/store';
import { UserIdleService } from 'angular-user-idle';
import { Login } from 'master-locations-library/master-locations-library/src/lib/presentation/state/master-locations-global.actions';
import { PrimeNG } from 'primeng/config';
import { filter, map, Subject, takeUntil } from 'rxjs';

@Component({
  imports: [RouterModule],
  selector: 'core-ui-master-locations-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private router: Router,
    private primeNg: PrimeNG,
    private userIdle: UserIdleService,
    private store: Store,
    private iconLoader: IconLoaderService
  ) {
    this.iconLoader.loadSprite(
      'https://saas-ui-assets.cubivue.com/assets/img/cubivue-icons.svg'
    );
  }

  ngOnInit(): void {
    this.primeNg.ripple.set(true);
    this.setPageTitle();

    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe();

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.store.dispatch(new Login(undefined));
      // this.router.navigate(['/accounts/login']).then();
      this.userIdle.resetTimer();
      window.location.reload();
    });
  }

  ngAfterViewChecked(): void {
    this.setAutocompleteOff();
  }

  private setAutocompleteOff(): void {
    document.querySelectorAll('.form-control').forEach((element) => {
      element.setAttribute('autocomplete', 'off');
    });
  }

  private setPageTitle(): void {
    const defaultPageTitle = 'Location Portal';

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;

          if (!child) {
            return (
              this.activatedRoute.snapshot.data['title'] || defaultPageTitle
            );
          }

          while (child.firstChild) {
            child = child.firstChild;
          }

          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
        })
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((title: string) =>
        this.title.setTitle(`${title} - ${defaultPageTitle}`)
      );
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
